import(/* webpackMode: "eager" */ "/vercel/path0/apps/storefront/app/[lang]/pages/careers/[handle]/job-details.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["RenderBlock"] */ "/vercel/path0/apps/storefront/app/components/legacy-slice-renderer/legacy-slice-renderer.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/storefront/public/images/small_icon/icon-openinnew.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
